/** The count beside "Inbox" in the sidebar (1.N-1 deliverable 3). */
import { flagsFromMe, tid } from '@codex/contracts';
import { useShellSession } from '../shell/session.js';
import { useInboxCounts } from './counts.js';
import { badgeLabel, badgeText, totalOpen } from './inbox-model.js';
import './inbox.css';

export function InboxCountBadge(): React.JSX.Element | null {
  const me = useShellSession();
  if (me === null || !flagsFromMe(me).catalogue) return null;
  return <Badge />;
}

function Badge(): React.JSX.Element {
  const { data } = useInboxCounts();
  const n = totalOpen(data);
  return (
    <span
      className="cx-inbox-badge"
      role="status"
      aria-label={badgeLabel(n)}
      data-empty={n <= 0 ? '' : undefined}
      {...tid('inbox.counts.badge')}
    >
      {badgeText(n)}
    </span>
  );
}
